import { type Routes } from '@angular/router';

import { administratorCanActivate } from './core/administrator.guard';
import { authCanActivate, authCanMatch } from './core/auth.guard';
import { ROUTER_LINKS } from './interfaces/router-links.enum';
import { LogoutComponent } from './logout/logout.component';

export const appRoutes: Routes = [
  {
    path: ROUTER_LINKS.STAFF,
    loadChildren: () => import('./staff/staff.routes').then(m => m.staffRoutes),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate, administratorCanActivate]
  },
  {
    path: ROUTER_LINKS.SETTINGS,
    loadChildren: () => import('./settings/settings.routes').then(m => m.settingsRoutes),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate]
  },
  {
    path: ROUTER_LINKS.HOME,
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate]
  },
  {
    path: ROUTER_LINKS.ONBOARDING,
    loadChildren: () => import('./onboarding/onboarding.routes').then(m => m.onboardingRoutes),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate]
  },
  {
    path: ROUTER_LINKS.TEAM,
    loadComponent: () => import('./team/team.component').then(m => m.TeamComponent),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate]
  },
  {
    path: ROUTER_LINKS.REGISTRY_REVIEW,
    loadComponent: () => import('./review/review.component').then(m => m.ReviewComponent),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate]
  },
  {
    path: ROUTER_LINKS.ANALYTICS,
    loadComponent: () => import('./analytics/analytics.component').then(m => m.AnalyticsComponent),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate, administratorCanActivate]
  },
  {
    path: ROUTER_LINKS.PREVIEW,
    loadComponent: () => import('./preview-content/preview-content.component').then(m => m.PreviewContentComponent),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate, administratorCanActivate]
  },
  {
    path: ROUTER_LINKS.DEACTIVATED,
    loadComponent: () =>
      import('./deactivated-screen/deactivated-screen.component').then(m => m.DeactivatedScreenComponent),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate]
  },
  {
    path: ROUTER_LINKS.KNOWLEDGE_BASE,
    loadComponent: () =>
      import('./knowledge-base/knowledge-base-list/knowledge-base-list.component').then(
        m => m.KnowledgeBaseListComponent
      ),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate],
    data: {
      title: 'home',
      rootLink: ROUTER_LINKS.HOME
    }
  },
  {
    path: `${ROUTER_LINKS.KNOWLEDGE_BASE}/:knowledgeBaseId`,
    loadComponent: () =>
      import('./knowledge-base/knowledge-base-detail/knowledge-base-detail.component').then(
        m => m.KnowledgeBaseDetailComponent
      ),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate],
    data: {
      title: 'home',
      rootLink: ROUTER_LINKS.HOME
    }
  },
  {
    path: ROUTER_LINKS.HOME_CONTENT,
    loadChildren: () => import('./news/news.routes').then(m => m.newsRoutes),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate],
    data: {
      title: 'home',
      rootLink: ROUTER_LINKS.HOME,
      rootPath: ROUTER_LINKS.HOME_CONTENT,
      releaseToPublic: true
    }
  },
  {
    path: ROUTER_LINKS.PREVIEW_CONTENT,
    loadChildren: () => import('./news/news.routes').then(m => m.newsRoutes),
    canMatch: [authCanMatch],
    canActivate: [authCanActivate, administratorCanActivate],
    data: {
      title: 'previewContent',
      rootLink: ROUTER_LINKS.PREVIEW,
      rootPath: ROUTER_LINKS.PREVIEW_CONTENT,
      releaseToPublic: false
    }
  },
  {
    path: ROUTER_LINKS.LOGOUT,
    component: LogoutComponent
  },
  {
    path: '**',
    redirectTo: ROUTER_LINKS.HOME
  }
];
